// Full rebuild entire WF Route with new signs order
export const handleFullRebuildWFRouteWithNewSignsOrder = (
  route: any,
  newSignsOrder: any[],
  addNewRouteLine: () => any,
  calculateImgCenter: (img: any) => any,
  updateDrawingWithRouteItems: () => void
) => {
  // Create new lines for all segments
  const newLines: any[] = []
  for(let i = 0; i < newSignsOrder.length - 1; i++) {
    const line = addNewRouteLine()
    line.points = [
      ...calculateImgCenter(newSignsOrder[i]),
      ...calculateImgCenter(newSignsOrder[i + 1])
    ]
    newLines.push(line)
  }

  // Update route
  route.signsOrder = newSignsOrder
  route.lines = newLines

  // Update drawing
  updateDrawingWithRouteItems()
}
